<template>
    <div class="login">
        <h1>Sign in to MyStekz</h1>
        <div class="buttons" v-if="!showEmailPasswordInputs">
            <Button
                class="p-button-raised button"
                label="Sign in with Google"
                icon="google-icon"
                @click="signInThroughGoogle"
            >
                <template #icon>
                    <img
                        class="firebase-icon"
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                    />
                </template>
            </Button>
            <Button
                class="p-button-raised button"
                label="Sign in with email"
                @click="showEmailPasswordInputs = true"
            >
            </Button>
        </div>

        <div v-if="showEmailPasswordInputs" class="login-inputs">
            <Message v-if="errorMessage" :closable="false" severity="error">
                {{ errorMessage }}
            </Message>
            <div class="input email">
                <label for="email">Email</label>
                <InputText v-model="email" />
            </div>
            <div class="input password">
                <label for="password">Password</label>
                <Password v-model="password" :fluid="true" :feedback="false" />
            </div>

            <div class="buttons">
                <Button
                    class="p-button-raised button"
                    label="Cancel"
                    @click="showEmailPasswordInputs = false"
                >
                </Button>
                <Button
                    class="p-button-raised button"
                    label="Sign in"
                    @click="signInWithEmail"
                >
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { authentication } from "@/lib/integrations/index.js";
const showEmailPasswordInputs = ref(false);
const errorMessage = ref<string>();
const email = ref("");
const password = ref("");

const router = useRouter();

const onAuthenticated = () => {
    router.push("/");
};

const signInThroughGoogle = () => {
    authentication.signIn("firebase");
};

const signInWithEmail = async () => {
    errorMessage.value = "";
    try {
        await authentication.signIn(
            "firebase",
            `${email.value}`,
            `${password.value}`
        );
    } catch {
        errorMessage.value = "Incorrect email/password combination";
    }
};

onMounted(() => {
    authentication.events.addEventListener("authenticated", onAuthenticated);
});

onUnmounted(() => {
    authentication.events.removeEventListener("authenticated", onAuthenticated);
});
</script>

<style lang="scss" scoped>
div.login {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    padding: 30px;
    align-items: center;
    color: var(--stekz-white);
    background-color: var(--stekz-primary-color);

    h1 {
        color: var(--stekz-white);
    }

    > div {
        max-width: 320px;
    }
}

.buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 20px;
}

.button {
    background-color: var(--stekz-dev-color);
    color: var(--stekz-white);
    width: 300px;
}

button.back-button,
button.firebase-login,
button.email-password-login {
    margin-top: 10px;
    color: var(--stekz-white);
    background-color: var(--stekz-dev-color);
    direction: ltr;
    font-weight: 500;
    height: auto;
    line-height: normal;
    min-height: 40px;
    padding: 8px 16px;
    text-align: center;
    width: 100%;
    position: relative;
    height: 36px;
    min-width: 64px;
    padding: 0 16px;
    display: inline-block;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 14px;
    letter-spacing: 0;
    overflow: hidden;
    outline: none;
    text-decoration: none;
    vertical-align: middle;
    border: 1px #757575 solid;
    border-radius: 3px;
}

button.firebase-login > span {
    display: table-cell;
}

.google-icon {
    background-image: url("https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg");
}

img.firebase-icon {
    border: none;
    display: inline-block;
    height: 18px;
    vertical-align: middle;
    width: 18px;
}

span.back-text,
span.email-login-text {
    color: #757575;
    display: table-cell;
    font-size: 14px;
    padding-left: 33px;
    vertical-align: middle;
}

.login-inputs > div.input {
    margin-bottom: 0.5rem;
}

.login-inputs .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
}

.input.email {
    display: flex;
    flex-direction: column;
}
.input.password {
    display: flex;
    flex-direction: column;
}
</style>
